// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3AndD","large":"styles_large__3qH6g"};